function AlisaIcon() {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#alisa_clip)">
                <path
                    d="M1.37479 3.20784V2.29131C1.37479 2.04823 1.47135 1.81511 1.64323 1.64323C1.81511 1.47135 2.04823 1.37479 2.29131 1.37479H3.20784"
                    stroke="#CE6011"
                    strokeWidth="0.916667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.79167 1.375H8.70819C8.95127 1.375 9.18439 1.47156 9.35627 1.64344C9.52815 1.81533 9.62472 2.04845 9.62472 2.29153V3.20805"
                    stroke="#CE6011"
                    strokeWidth="0.916667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.62472 7.79167V8.70819C9.62472 8.95127 9.52815 9.18439 9.35627 9.35627C9.18439 9.52815 8.95127 9.62472 8.70819 9.62472H7.79167"
                    stroke="#CE6011"
                    strokeWidth="0.916667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.20805 9.62472H2.29153C2.04845 9.62472 1.81533 9.52815 1.64344 9.35627C1.47156 9.18439 1.375 8.95127 1.375 8.70819V7.79167"
                    stroke="#CE6011"
                    strokeWidth="0.916667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3.20833 3.66667H6.87443" stroke="#CE6011" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3.20833 5.5H7.79096" stroke="#CE6011" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3.20833 7.33333H5.95791" stroke="#CE6011" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="alisa_clip">
                    <rect width="11" height="11" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default AlisaIcon;
